// library's

import React from 'react'

// style's
import "./Video.css";

export const Video = ({video}) => {


    return (
        <video src={video} />
    )
}
